import { render, staticRenderFns } from "./xw.vue?vue&type=template&id=3ff61327&scoped=true"
import script from "./xw.vue?vue&type=script&lang=js"
export * from "./xw.vue?vue&type=script&lang=js"
import style0 from "./xw.vue?vue&type=style&index=0&id=3ff61327&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff61327",
  null
  
)

export default component.exports